import { useEffect, useState } from "react";
import { BookmarkPlus, BookmarkCheck } from "lucide-react";
import { isSaved, saveWord, removeWord, contentWords } from "@/lib/vocab";

export const useVocabTick = () => {
  const [, set] = useState(0);
  useEffect(() => { const h = () => set((x) => x + 1); window.addEventListener("lexv-vocab", h); return () => window.removeEventListener("lexv-vocab", h); }, []);
};

export const SaveWordButton = ({ word, context, part }) => {
  useVocabTick();
  const saved = isSaved(word);
  return (
    <button data-testid={`save-word-${word}`} onClick={() => (saved ? removeWord(word.toLowerCase()) : saveWord(word, context, part))}
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-medium transition-colors ${saved ? "border-indigo-300 bg-indigo-600 text-white" : "border-slate-300 bg-white text-slate-700 hover:border-indigo-400 hover:text-indigo-700"}`}>
      {saved ? <BookmarkCheck className="h-3 w-3" /> : <BookmarkPlus className="h-3 w-3" />}{word}
    </button>
  );
};

const missedFrom = (partKey, item, result) => {
  if (partKey === "F" && !result.correct) return item.answers.slice(0, 1);
  if (result.missed && partKey === "H") return result.missed;
  if (result.diff && partKey !== "E") return result.diff.ops.filter((o) => o.t === "miss").map((o) => o.w);
  return [];
};

export const SaveMissedWords = ({ partKey, item, result }) => {
  const words = contentWords(missedFrom(partKey, item, result)).slice(0, 12);
  if (!words.length) return null;
  const context = item.text || item.sentence?.replace(/_{2,}/, item.answers?.[0] || "___") || item.answer || "";
  return (
    <div data-testid="save-missed-words" className="space-y-2 rounded-lg border border-indigo-100 bg-indigo-50/50 p-3">
      <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-indigo-600">Save missed words to your notebook</div>
      <div className="flex flex-wrap gap-1.5">{words.map((w) => <SaveWordButton key={w} word={w} context={context} part={partKey} />)}</div>
    </div>
  );
};
